import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { RxdbCollectionName } from '../rxdbCollectionName';
import type { TrafficSafetyScore, TrafficSafetyScoreCollection } from './trafficSafetyScore.types';

const useTrafficSafetyScore = () => {
  const getTrafficSafetyScoreQuery = useCallback(
    (collection: TrafficSafetyScoreCollection) => collection?.find(),
    [],
  );

  const { result: trafficSafetyScoreListData } = useRxData<TrafficSafetyScore>(
    RxdbCollectionName.TRAFFIC_SAFETY_SCORE,
    getTrafficSafetyScoreQuery,
    { json: true },
  );

  return { trafficSafetyScoreListData };
};

export default useTrafficSafetyScore;
